export default __webpack_public_path__ + "static/media/san-rafael-2.a77f7e31.jpg";